var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToolTipArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.106,
    height: 7.333,
    viewBox: "0 0 15.106 7.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_38593",
    "data-name": "Group 38593",
    transform: "translate(14312.819 -69)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_30",
    "data-name": "Subtraction 30",
    d: "M25.733,92.333a2.993,2.993,0,0,1-2.3-1.071L18.18,85H33.286l-5.255,6.262A2.993,2.993,0,0,1,25.733,92.333Z",
    transform: "translate(-14331 -16)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_30_-_Outline",
    "data-name": "Subtraction 30 - Outline",
    d: "M25.733,91.833a2.5,2.5,0,0,0,1.915-.893L32.62,85H18.849l4.969,5.941a2.5,2.5,0,0,0,1.915.893m0,.5a2.993,2.993,0,0,1-2.3-1.071L18.18,85H33.286l-5.255,6.262A2.993,2.993,0,0,1,25.733,92.333Z",
    transform: "translate(-14331 -16)",
    fill: "#0043e3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolTipArrow);
export default __webpack_public_path__ + "static/media/tool_tip_arrow.89d2dd3f.svg";
export { ForwardRef as ReactComponent };